import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "./css/Home.css";
import Banner from "./Banner";
import BotonesHome from "./BotonesHome";
import ExplorarHome from "./ExplorarHome";
import Footer from "./Footer";
import UltimoRecuerdo from "./UltimoRecuerdo";
import AdminOnly from "../secondary/AdminOnly";
// import ToggleVersion from "../../ToggleVersion";

const Home = () => {
    useEffect(() => {
        const root = document.getElementById("root");
        if (root) {
            root.scrollIntoView({ behavior: "auto" });
        }
    }, []);

    return (
        <div className="home-container">
            <Banner />
            <BotonesHome />
            <ExplorarHome />
            <AdminOnly>
                <UltimoRecuerdo />
            </AdminOnly>
            <Footer />
            {/* <ToggleVersion /> */}
        </div>
    );
};

export default Home;
